import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "400",
  height: "400",
  fill: "currentColor",
  class: "icon",
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M693.333 128a32 32 0 0 1 32 32v32H800a117.333 117.333 0 0 1 117.248 112.619l.085 4.714v448a117.333 117.333 0 0 1-112.618 117.248l-4.715.086H224a117.333 117.333 0 0 1-117.248-112.619l-.085-4.715v-448a117.333 117.333 0 0 1 112.618-117.248L224 192h74.667v-32a32 32 0 0 1 64 0v32h298.666v-32a32 32 0 0 1 32-32m160 298.667H170.667v330.666A53.333 53.333 0 0 0 220.5 810.56l3.499.107h576a53.333 53.333 0 0 0 53.227-49.835l.106-3.499zM714.667 661.333a32 32 0 0 1 0 64H288a32 32 0 0 1 0-64zM437.333 512a32 32 0 0 1 0 64H288a32 32 0 0 1 0-64zM298.667 256H224a53.333 53.333 0 0 0-53.227 49.835l-.106 3.498v53.334h682.666v-53.334a53.333 53.333 0 0 0-49.834-53.226L800 256h-74.667v10.667a32 32 0 0 1-64 0V256H362.667v10.667a32 32 0 0 1-64 0z" }, null, -1)
  ])))
}
export default { render: render }